import { useRouter } from 'next/router'
import { Trans, useTranslation } from 'next-i18next'

import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { AppLanguage } from '~/types/locale'

const i18nActionPointKeys = ['item1', 'item2', 'item3'] as const

const mediaQuery = [
  { screen: '(max-width: 767px)', width: '500px' },
  { screen: '(min-width: 768px)', width: '600px' },
]

export default function StudentPanel({ className = '' }): React.ReactElement {
  const { t } = useTranslation('tutorOnDemand')
  const { locale: language } = useRouter()

  const getStudentPanelScreenshotSrcKey = (lang: string | undefined): string => {
    switch (lang) {
      case AppLanguage.NO:
        return 'mentor-on-demand/student-panel-screenshot-no.png'
      case AppLanguage.UA:
        return 'mentor-on-demand/student-panel-screenshot-ua.png'
      default:
        return 'mentor-on-demand/student-panel-screenshot-en.png'
    }
  }

  return (
    <div className={`text-black-light ${className}`}>
      <div className="max-w-7xl mx-auto">
        <section className="max-w-4xl mx-auto text-black-light-fade">
          <h2 className="mb-6 text-h3 font-light leading-10">
            {Trans({
              t,
              i18nKey: 'landingPage.studentPanel.title',
              components: { strong: <strong className="font-semibold" /> },
              children: t('landingPage.studentPanel.title'),
            })}
          </h2>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <ResponsiveImage
              alt={t('landingPage.studentPanel.title')}
              height={250}
              imageClassName="w-full max-w-100 sm:w-98 rounded shadow-large"
              imageWidths="500, 600"
              loading="lazy"
              mediaQuery={mediaQuery}
              srcKey={getStudentPanelScreenshotSrcKey(language)}
              width={400}
            />

            <div>
              <p className="mb-4 font-light sm:text-md leading-8 whitespace-pre-line">
                {Trans({
                  t,
                  i18nKey: 'landingPage.studentPanel.text',
                  components: { strong: <strong className="font-semibold" /> },
                  children: t('landingPage.studentPanel.text'),
                })}
              </p>

              <ol className="list-outside space-y-2 font-light">
                {i18nActionPointKeys.map((elem, idx) => (
                  <li className="space-x-1 flex sm:text-md leading-8" key={elem}>
                    <span className="shrink-0 w-4 text-center font-semibold">{idx + 1}.</span>
                    <span>{t(`landingPage.studentPanel.list.${elem}`)}</span>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}
